<script setup>
const props = defineProps({
  ann: {
    type: Object,
    required: true,
  },
  editing: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isMenu: {
    type: Boolean,
    default: false,
  },
  isEnd: {
    type: Boolean,
    default: false,
  },
});

import { VideoStore } from "@/front/stores/video_store.js";
import { PlayerStore } from "@/front/stores/player_store.js";
import { AnnStore } from "@/front/stores/ann_store.js";
const annStore = AnnStore();
import { PositionCalculator } from "@/front/composables/PositionCalculator.js";
const { calculatePosition } = PositionCalculator();
const { t } = useI18n();

const videoStore = VideoStore();
const playerStore = PlayerStore();

const customStyle =
  (props.ann.customStyle && JSON.parse(props.ann.customStyle)) || {};
log.info(5,customStyle);
const styling = computed(() => {
  let hasIframe = props.ann.content.includes('<iframe')
  const baseDesign = videoStore.video.design || {};
  const widthRatio = playerStore.playerState.width / (props.ann.og_width || customStyle.videoWidth || 1920);
  let bgColor =
    props.ann.background_color ||
    customStyle.background_color ||
    baseDesign.comment_background_color ||
    "red";
  let textColor =
    props.ann.text_color || customStyle.color || baseDesign.comment_text_color;
  let opacity = props.disabled ? 0.5 : 1;
  let cursor = (props.disabled || isNoneClickAction.value) ? "not-allowed" : "pointer";

  if (props.ann.post_click_state == "color" && props.ann.clicked) {
    bgColor = props.ann.post_click_color;
    textColor = props.ann.post_click_text_color;
  }

  const dimensions = calculatePosition(props.ann);
  return {
    shell: {
      width: props.editing ? "100%" : `${dimensions.width}px`,
      height: props.editing ? "100%" : `${dimensions.height}px`,
      left: props.editing ? "0px" : `${dimensions.left}px`,
      top: props.editing ? "0px" : `${dimensions.top}px`,
      minHeight: `${dimensions.minHeight}px`,
      fontSize: `${dimensions.fontSize}px`,
      textAlign: customStyle.textAlign || props.ann.text_align || "center",
    },
    content: {
      background:
        props.ann.background_color ||
        customStyle.background_color ||
        baseDesign.comment_background_color,
      padding: hasIframe ? "0px" : "0.3em 0.5em",
      width: hasIframe ? "100%" : "fit-content",
      margin:
        props.ann.text_align == "left"
          ? "0 0 0 0"
          : props.ann.text_align == "right"
          ? "0 0 0 auto"
          : "0 auto",
      color: textColor,
      background: bgColor,
      borderColor:
        props.ann.borderColor ||
        customStyle.borderColor ||
        baseDesign.comment_border_color ||
        "red",
      borderRadius:
        Math.min(widthRatio *
          ((props.ann.border_radius ||
            customStyle.borderRadius ||
            baseDesign.comment_border_radius) /
            10), 1) +
        "em",
      fontWeight: "bold",
      opacity: opacity,
      cursor: cursor,
    },
  };
});
const isHovering = ref(false);

const handleMouseEnter = () => {
  isHovering.value = true;
};

const handleMouseLeave = () => {
  isHovering.value = false;
};

const transformedContent = computed(() => {
  return (annStore.isEditing || videoStore.video.manage ? props.ann.content : props.ann.transformed_content) || (annStore.isEditing ? t("common.enter_content") : "")
})

const isNoneClickAction = computed(() => {
  return props.ann.click_action == 'none'
})

</script>

<template>
  <div
    :style="styling.shell"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    class="touch-manipulation"
    :class="{[`hover:scale-105 z-10 ${ann.animation} active:scale-[90%]`]: !disabled && !isNoneClickAction}"
  >
    <div
      v-if="!annStore.isEditing"
      class="text-content select-none"
      :data-id="ann.id"
      :class="{'spotlightMode': props.ann.do_spotlight}"
      :style="styling.content"
      v-safe-html="transformedContent"
    ></div>
    <div
      v-else
      class="text-content select-none"
      :class="{'spotlightMode': props.ann.do_spotlight}"
      :style="styling.content"
      v-safe-html="transformedContent"
      v-once
    ></div>
  </div>
</template>
